import React from "react";
import { Button, Modal } from "react-blueprint-library";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import Moment from "moment";
import "../StartApplication.scss";
import "../../../assets/stylesheets/StartApplication/CAS/PersonalSalesRecordModal.scss";
import {
  insertPSRRecord,
  getPSRRecord,
  updatePSRRecord,
} from "../../../api/makeAPIRequest";
import {
  onlyNumeric,
  pasteCommaDelimited,
  pasteValue,
} from "../../../common/Functions";
import LostDataModal from "../../SharedComponents/LostDataModal";
import ModalLoader from "../../SharedComponents/Loaders/ModalLoader";

class PersonalSalesRecordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
    this.nextClick = this.nextClick.bind(this);
    this.addClick = this.addClick.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.backClick = this.backClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.handleInvestmentProductsChange =
      this.handleInvestmentProductsChange.bind(this);
    this.handleFeeBasedChange = this.handleFeeBasedChange.bind(this);
    this.handleFinancialPlanningChange =
      this.handleFinancialPlanningChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseBackModal = this.handleCloseBackModal.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.props.reviewEditData.startdate !== this.state.startdate ||
      this.props.reviewEditData.enddate !== this.state.enddate ||
      this.props.reviewEditData.companyname !== this.state.companyname ||
      this.props.reviewEditData.jobtitle !== this.state.jobtitle
    ) {
      var showLTCPanel = false;
      if (this.props.reviewEditData.solicitindltc === true) {
        showLTCPanel = true;
      }
      var showLifePanel = false;
      if (this.props.reviewEditData.solicitindlife === true) {
        showLifePanel = true;
      }
      var showDisabilityPanel = false;
      if (this.props.reviewEditData.solicitinddisability === true) {
        showDisabilityPanel = true;
      }
      var showAnnuityPanel = false;
      if (this.props.reviewEditData.solicitindannuity === true) {
        showAnnuityPanel = true;
      }

      await this.setState({
        employment_history_id: this.props.reviewEditData.employmenthistoryid,
        candidate_id: this.props.reviewEditData.candidateId,
        jobtitle: this.props.reviewEditData.jobtitle,
        startdate: this.props.reviewEditData.startdate,
        enddate: this.props.reviewEditData.enddate,
        companyname: this.props.reviewEditData.companyname,
        show_individual_annuity_panel: showAnnuityPanel,
        show_individual_disability_income_panel: showDisabilityPanel,
        show_individual_life_insurance_panel: showLifePanel,
        show_individual_long_term_care_panel: showLTCPanel,
        review_edit: false,
        ind_life_first_year: "",
        ind_life_first_year_error: false,
        ind_life_renewal: "",
        ind_life_renewal_error: false,
        ind_annuity_first_year: "",
        ind_annuity_first_year_error: false,
        ind_annuity_renewal: "",
        ind_annuity_renewal_error: false,
        ind_disability_first_year: "",
        ind_disability_first_year_error: false,
        ind_disability_renewal: "",
        ind_disability_renewal_error: false,
        ind_longterm_first_year: "",
        ind_longterm_first_year_error: false,
        ind_longterm_renewal: "",
        ind_longterm_renewal_error: false,
        psr_id: 0,
        form_has_changed: false,
      });

      if (this.props.reviewEditData.psr_id > 0) {
        var result = await getPSRRecord(
          this.props.subId,
          this.props.reviewEditData.psr_id,
        );

        if (result.sellinvproducts === true) {
          this.setState({
            investment_products: "Y",
            show_investment_products: true,
          });
        } else {
          this.setState({
            investment_products: "N",
            show_investment_products: false,
          });
        }
        if (result.feebasedsales === true) {
          this.setState({ fee_based: "Y", show_fee_based: true });
        } else {
          this.setState({ fee_based: "N", show_fee_based: false });
        }
        if (result.sellfinplanning === true) {
          this.setState({
            financial_planning: "Y",
            show_financial_planning: true,
          });
        } else {
          this.setState({
            financial_planning: "N",
            show_financial_planning: false,
          });
        }

        if (result.indlifirstyear !== null) {
          var indFirstYearLife = Math.trunc(result.indlifirstyear).toString();
          var commaSeparatedNumber = indFirstYearLife
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_life_first_year: commaSeparatedNumber,
          });
        }
        if (result.indlirenewcom !== null) {
          var indLifeRen = Math.trunc(result.indlirenewcom).toString();
          commaSeparatedNumber = indLifeRen.split(/(?=(?:\d{3})+$)/).join(",");
          await this.setState({
            ind_life_renewal: commaSeparatedNumber,
          });
        }
        if (result.indannfirstyear !== null) {
          var indFirstYearAnnuity = Math.trunc(
            result.indannfirstyear,
          ).toString();
          commaSeparatedNumber = indFirstYearAnnuity
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_annuity_first_year: commaSeparatedNumber,
          });
        }
        if (result.indannrenewcom !== null) {
          var indAnnuityRen = Math.trunc(result.indannrenewcom).toString();
          commaSeparatedNumber = indAnnuityRen
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_annuity_renewal: commaSeparatedNumber,
          });
        }
        if (result.inddisincfirstyear !== null) {
          var indFirstYearDisability = Math.trunc(
            result.inddisincfirstyear,
          ).toString();
          commaSeparatedNumber = indFirstYearDisability
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_disability_first_year: commaSeparatedNumber,
          });
        }
        if (result.inddisincrenewcom !== null) {
          var indDisabilityRen = Math.trunc(
            result.inddisincrenewcom,
          ).toString();
          commaSeparatedNumber = indDisabilityRen
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_disability_renewal: commaSeparatedNumber,
          });
        }
        if (result.indlongtermfirstyear !== null) {
          var indFirstYearLongTerm = Math.trunc(
            result.indlongtermfirstyear,
          ).toString();
          commaSeparatedNumber = indFirstYearLongTerm
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_longterm_first_year: commaSeparatedNumber,
          });
        }
        if (result.indlongtermrenewcom !== null) {
          var indLongTermRen = Math.trunc(
            result.indlongtermrenewcom,
          ).toString();
          commaSeparatedNumber = indLongTermRen
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            ind_longterm_renewal: commaSeparatedNumber,
          });
        }
        if (result.invprodgrossdealercom !== null) {
          var invProdGross = Math.trunc(
            result.invprodgrossdealercom,
          ).toString();
          commaSeparatedNumber = invProdGross
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            investment_product_gross: commaSeparatedNumber,
          });
        }

        if (result.feebasedsalesrelfees !== null) {
          var feeBasedSales = Math.trunc(
            result.feebasedsalesrelfees,
          ).toString();
          commaSeparatedNumber = feeBasedSales
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            fee_based_sales: commaSeparatedNumber,
          });
        }

        if (result.nrfinplanssell !== null) {
          var numFinPlanSell = Math.trunc(result.nrfinplanssell).toString();
          commaSeparatedNumber = numFinPlanSell
            .split(/(?=(?:\d{3})+$)/)
            .join(",");
          await this.setState({
            number_financial_plans: commaSeparatedNumber,
          });
        }

        this.setState({
          step_number: 1,
          is_next_disabled: false,
          employment_history_id: this.props.reviewEditData.employmenthistoryid,
          candidate_id: this.props.reviewEditData.candidateId,
          jobtitle: this.props.reviewEditData.jobtitle,
          startdate: this.props.reviewEditData.startdate,
          enddate: this.props.reviewEditData.enddate,
          companyname: this.props.reviewEditData.companyname,
          show_individual_annuity_panel: showAnnuityPanel,
          show_individual_disability_income_panel: showDisabilityPanel,
          show_individual_life_insurance_panel: showLifePanel,
          show_individual_long_term_care_panel: showLTCPanel,
          //number_financial_plans: result.nrfinplanssell,
          is_add_disabled: false,
          review_edit: true,
          psr_id: this.props.reviewEditData.psr_id,
        });
      } else if (this.props.reviewEditData.psr_id === 0) {
        await this.setState({
          employment_history_id: this.props.reviewEditData.employmenthistoryid,
          candidate_id: this.props.reviewEditData.candidateId,
          jobtitle: this.props.reviewEditData.jobtitle,
          startdate: this.props.reviewEditData.startdate,
          enddate: this.props.reviewEditData.enddate,
          companyname: this.props.reviewEditData.companyname,
          show_individual_annuity_panel: showAnnuityPanel,
          show_individual_disability_income_panel: showDisabilityPanel,
          show_individual_life_insurance_panel: showLifePanel,
          show_individual_long_term_care_panel: showLTCPanel,
          //personalsalesrecords: this.props.reviewEditData.personalsalesrecords,
          review_edit: false,
          ind_life_first_year: "",
          ind_life_renewal: "",
          ind_annuity_first_year: "",
          ind_annuity_renewal: "",
          ind_disability_first_year: "",
          ind_disability_renewal: "",
          ind_longterm_first_year: "",
          ind_longterm_renewal: "",
          psr_id: 0,
          is_next_disabled: true,
          step_number: 1,
          sell_investment: "",
          sell_fee_based: "",
          sell_financial_planning: "",
          investment_products: "",
          fee_based: "",
          financial_planning: "",
          show_investment_products: false,
          show_fee_based: false,
          show_financial_planning: false,
        });
      }
      //var endDateText = "";
      var endDateTmp = Moment(this.state.enddate).utc().format("MM/DD/YYYY");
      var today = Moment().format("MM/DD/YYYY");
      if (endDateTmp === today) {
        this.setState({ endDateText: "Present" });
      } else {
        this.setState({ endDateText: endDateTmp });
      }
    }
  }
  async validateFields() {
    await this.setState({
      is_add_disabled: true,
      is_next_disabled: true,
    });
    if (this.state.step_number === 1 && this.props.hasNYRegs === false) {
      var hasError = false;

      if (this.state.show_individual_life_insurance_panel === true) {
        if (
          this.state.ind_life_first_year === "" ||
          this.state.ind_life_renewal === ""
        ) {
          hasError = true;
        }
      }
      if (this.state.show_individual_annuity_panel === true) {
        if (
          this.state.ind_annuity_first_year === "" ||
          this.state.ind_annuity_renewal === ""
        ) {
          hasError = true;
        }
      }
      if (this.state.show_individual_disability_income_panel === true) {
        if (
          this.state.ind_disability_first_year === "" ||
          this.state.ind_disability_renewal === ""
        ) {
          hasError = true;
        }
      }
      if (this.state.show_individual_long_term_care_panel === true) {
        if (
          this.state.ind_longterm_first_year === "" ||
          this.state.ind_longterm_renewal === ""
        ) {
          hasError = true;
        }
      }
      if (hasError === false) {
        await this.setState({
          is_add_disabled: false,
          is_next_disabled: false,
        });
      }
    } else if (this.state.step_number === 1 && this.props.hasNYRegs === true) {
      hasError = false;

      if (
        this.state.show_individual_life_insurance_panel === true &&
        this.state.ind_life_first_year === ""
      ) {
        hasError = true;
      }
      if (
        this.state.show_individual_annuity_panel === true &&
        this.state.ind_annuity_first_year === ""
      ) {
        hasError = true;
      }
      if (
        this.state.show_individual_disability_income_panel === true &&
        this.state.ind_disability_first_year === ""
      ) {
        hasError = true;
      }
      if (
        this.state.show_individual_long_term_care_panel === true &&
        this.state.ind_longterm_first_year === ""
      ) {
        hasError = true;
      }
      if (hasError === false) {
        await this.setState({
          is_add_disabled: false,
          is_next_disabled: false,
        });
      }
    } else if (this.state.step_number === 2 && this.props.hasNYRegs === false) {
      hasError = false;

      if (
        this.state.investment_products === "Y" &&
        (this.state.investment_product_gross === "" ||
          parseInt(this.state.investment_product_gross) === 0)
      ) {
        hasError = true;
      }

      if (
        this.state.fee_based === "Y" &&
        (this.state.fee_based_sales === "" ||
          parseInt(this.state.fee_based_sales) === 0)
      ) {
        hasError = true;
      }

      if (
        this.state.financial_planning === "Y" &&
        (this.state.number_financial_plans === "" ||
          parseInt(this.state.number_financial_plans) === 0)
      ) {
        hasError = true;
      }

      if (
        this.state.investment_products === "" ||
        this.state.fee_based === "" ||
        this.state.financial_planning === ""
      ) {
        hasError = true;
      }

      if (hasError === false) {
        await this.setState({ is_add_disabled: false });
      }
    } else if (this.state.step_number === 2 && this.props.hasNYRegs === true) {
      hasError = false;

      if (
        this.state.financial_planning === "Y" &&
        (this.state.number_financial_plans === "" ||
          parseInt(this.state.number_financial_plans) === 0)
      ) {
        hasError = true;
      }

      if (
        //this.state.investment_products === "" ||
        //this.state.fee_based === "" ||
        this.state.financial_planning === ""
      ) {
        hasError = true;
      }

      if (hasError === false) {
        await this.setState({ is_add_disabled: false });
      }
    }
  }
  onKeyDown() {
    this.setState({ form_has_changed: true });
  }

  initialState() {
    return {
      step_number: 0,
      is_add_disabled: true,
      is_next_disabled: true,
      show_add_button: true,
      show_next_button: false,
      companyname: "",
      jobtitle: "",
      startdate: "",
      enddate: "",
      ind_life_first_year: "",
      ind_life_first_year_error: false,
      ind_life_renewal: "",
      ind_life_renewal_error: false,
      ind_annuity_first_year: "",
      ind_annuity_first_year_error: false,
      ind_annuity_renewal: "",
      ind_annuity_renewal_error: false,
      ind_disability_first_year: "",
      ind_disability_first_year_error: false,
      ind_disability_renewal: "",
      ind_disability_renewal_error: false,
      ind_longterm_first_year: "",
      ind_longterm_first_year_error: false,
      ind_longterm_renewal: "",
      ind_longterm_renewal_error: false,
      investment_product: "",
      fee_based: "",
      financial_planning: "",
      show_investment_products: false,
      show_fee_based: false,
      show_financial_planning: false,
      number_financial_plans: "",
      number_financial_plans_error: false,
      number_financial_plans_error_text: "",
      fee_based_sales: "",
      fee_based_sales_error: false,
      fee_based_sales_error_text: "",
      investment_product_gross: "",
      investment_product_gross_error: false,
      investment_product_gross_error_text: "",
      investment_products: "",
      // is_form_saved: false,
      review_edit: false,
      row_id: -1,
      show_individual_life_insurance_panel: false,
      show_individual_annuity_panel: false,
      show_individual_disability_income_panel: false,
      show_individual_long_term_care_panel: false,
      personalsalesrecords: [],
      employment_history_id: "",
      candidate_id: "",
      psr_id: "",
      endDateText: "",
      form_has_changed: false,
      showBackModal: false,
    };
  }
  async nextClick() {
    await this.setState({
      step_number: 2,
    });
    if (this.state.review_edit === true) {
      this.setState({ is_add_disabled: false });
    }

    let myRef = document.getElementById("top_element");
    myRef.scrollIntoView();
    this.validateFields();
  }
  async addClick() {
    //save record
    const sell_investment = this.state.investment_products === "Y";
    const sell_fee_based = this.state.fee_based === "Y";
    const sell_financial_planning = this.state.financial_planning === "Y";

    if (typeof this.state.ind_life_first_year === "undefined") {
      this.setState({ ind_life_first_year: "" });
    }
    if (typeof this.state.ind_life_renewal === "undefined") {
      this.setState({ ind_life_renewal: "" });
    }
    if (typeof this.state.ind_annuity_first_year === "undefined") {
      this.setState({ ind_annuity_first_year: "" });
    }
    if (typeof this.state.ind_annuity_renewal === "undefined") {
      this.setState({ ind_annuity_renewal: "" });
    }
    if (typeof this.state.ind_disability_first_year === "undefined") {
      this.setState({ ind_disability_first_year: "" });
    }
    if (typeof this.state.ind_disability_renewal === "undefined") {
      this.setState({ ind_disability_renewal: "" });
    }
    if (typeof this.state.ind_longterm_first_year === "undefined") {
      this.setState({ ind_longterm_first_year: "" });
    }
    if (typeof this.state.ind_longterm_renewal === "undefined") {
      this.setState({ ind_longterm_renewal: "" });
    }
    var lifeFirstYear = 0;
    if (
      this.state.ind_life_first_year !== "" &&
      this.state.ind_life_first_year !== null
    ) {
      lifeFirstYear = parseInt(
        this.state.ind_life_first_year.replaceAll(",", ""),
      );
    }
    var lifeRenewal = 0;
    if (
      this.state.ind_life_renewal !== "" &&
      this.state.ind_life_renewal !== null
    ) {
      lifeRenewal = parseInt(this.state.ind_life_renewal.replaceAll(",", ""));
    }
    var annuityFirstYear = 0;
    if (
      this.state.ind_annuity_first_year !== "" &&
      this.state.ind_annuity_first_year !== null
    ) {
      annuityFirstYear = parseInt(
        this.state.ind_annuity_first_year.replaceAll(",", ""),
      );
    }
    var annuityRenewal = 0;
    if (
      this.state.ind_annuity_renewal !== "" &&
      this.state.ind_annuity_renewal !== null
    ) {
      annuityRenewal = parseInt(
        this.state.ind_annuity_renewal.replaceAll(",", ""),
      );
    }
    var disabilityFirstYear = 0;
    if (
      this.state.ind_disability_first_year !== "" &&
      this.state.ind_disability_first_year !== null
    ) {
      disabilityFirstYear = parseInt(
        this.state.ind_disability_first_year.replaceAll(",", ""),
      );
    }
    var disabilityRenewal = 0;
    if (
      this.state.ind_disability_renewal !== "" &&
      this.state.ind_disability_renewal !== null
    ) {
      disabilityRenewal = parseInt(
        this.state.ind_disability_renewal.replaceAll(",", ""),
      );
    }
    var longtermFirstYear = 0;
    if (
      this.state.ind_longterm_first_year !== "" &&
      this.state.ind_longterm_first_year !== null
    ) {
      longtermFirstYear = parseInt(
        this.state.ind_longterm_first_year.replaceAll(",", ""),
      );
    }
    var longtermRenewal = 0;
    if (
      this.state.ind_longterm_renewal !== "" &&
      this.state.ind_longterm_renewal !== null
    ) {
      longtermRenewal = parseInt(
        this.state.ind_longterm_renewal.replaceAll(",", ""),
      );
    }
    var invProdGross = null;
    if (
      this.state.investment_product_gross !== "" &&
      this.state.investment_product_gross !== null
    ) {
      invProdGross = parseInt(
        this.state.investment_product_gross.replaceAll(",", ""),
      );
    }
    var feeBasedSales = null;
    if (
      this.state.fee_based_sales !== "" &&
      this.state.fee_based_sales !== null
    ) {
      feeBasedSales = parseInt(this.state.fee_based_sales.replaceAll(",", ""));
    }

    var nrfinplansell = null;
    if (
      this.state.number_financial_plans !== "" &&
      this.state.number_financial_plans !== null
    ) {
      nrfinplansell = parseInt(
        this.state.number_financial_plans.replaceAll(",", ""),
      );
    }

    let data = {
      candidateid: this.props.candidateId,
      startdate: this.state.startdate,
      enddate: this.state.enddate,
      indlifirstyear: lifeFirstYear,
      indlirenewcom: lifeRenewal,
      indannfirstyear: annuityFirstYear,
      indannrenewcom: annuityRenewal,
      inddisincfirstyear: disabilityFirstYear,
      inddisincrenewcom: disabilityRenewal,
      indlongtermfirstyear: longtermFirstYear,
      indlongtermrenewcom: longtermRenewal,
      sellinvproducts: sell_investment,
      invprodgrossdealercom: invProdGross,
      feebasedsales: sell_fee_based,
      feebasedsalesrelfees: feeBasedSales,
      sellfinplanning: sell_financial_planning,
      nrfinplanssell: nrfinplansell,
    };

    // insert or update?
    if (this.state.review_edit !== true) {
      //insert new
      this.setState({ step_number: 0 });

      await insertPSRRecord(
        this.props.subId,
        this.state.employment_history_id,
        data,
      );
    } else {
      //update existing
      await updatePSRRecord(this.props.subId, this.state.psr_id, data);
    }

    this.props.showAlert();
    this.props.actionCancel(this.state);
    this.resetFields();
  }
  async cancelClick() {
    this.resetFields();
    this.props.actionCancel(null);
  }
  async backClick() {
    await this.setState({
      step_number: 1,
      is_next_disabled: false,
      show_next_button: true,
      show_add_button: false,
    });
    let myRef = document.getElementById("top_element");
    myRef.scrollIntoView();
  }
  async handleChange(event) {
    await this.setState({
      [event.target.id]: event.target.value,
      is_form_saved: false,
    });

    if (
      event.target.id.startsWith("ind_") ||
      event.target.id.startsWith("fee_based_sales") ||
      event.target.id.startsWith("investment_product_gross") ||
      event.target.id.startsWith("number_financial_plans")
    ) {
      var tempNumber = event.target.value.replace(/,/gi, "");
      var commaSeparatedNumber = tempNumber.split(/(?=(?:\d{3})+$)/).join(",");
      await this.setState({ [event.target.id]: commaSeparatedNumber });
    }

    //this.props.hasCurrentFormChanged(true);
    this.setState({ form_has_changed: true });
    this.validateFields();
  }
  resetFields() {
    this.setState(this.initialState());
  }
  async handleInvestmentProductsChange(event) {
    await this.setState({ investment_products: event.target.value });

    if (event.target.value === "Y") {
      this.setState({ show_investment_products: true });
    } else {
      this.setState({
        show_investment_products: false,
        investment_product_gross: "",
      });
    }
    this.setState({ form_has_changed: true });
    this.validateFields();
  }
  async handleFeeBasedChange(event) {
    await this.setState({ fee_based: event.target.value });

    if (event.target.value === "Y") {
      this.setState({ show_fee_based: true });
    } else {
      this.setState({ show_fee_based: false, fee_based_sales: "" });
    }
    this.setState({ form_has_changed: true });
    this.validateFields();
  }
  async handleFinancialPlanningChange(event) {
    await this.setState({ financial_planning: event.target.value });

    if (event.target.value === "Y") {
      this.setState({ show_financial_planning: true });
    } else {
      this.setState({
        show_financial_planning: false,
        number_financial_plans: "",
      });
    }
    this.setState({ form_has_changed: true });
    this.validateFields();
  }
  async onBlur(event) {
    if (event.target.id.startsWith("ind_")) {
      const hasError = event.target.value.trim(" ").length < 1;
      this.setState({
        [event.target.id + "_error"]: hasError,
        formHasError: hasError,
      });
    } else if (event.target.id === "number_financial_plans") {
      let fin_plan_error = false;
      let errorText = "";
      if (event.target.value === "") {
        fin_plan_error = true;
        errorText = "Please enter how many Financial Plans you sold";
      }
      if (parseInt(event.target.value) === 0) {
        fin_plan_error = true;
        errorText = "Please enter a value greater than zero";
      }

      await this.setState({
        number_financial_plans_error: fin_plan_error,
        number_financial_plans_error_text: errorText,
        formHasError: fin_plan_error,
      });
    } else if (event.target.id === "fee_based_sales") {
      let fee_based_error = false;
      let errorText = "";

      if (event.target.value === "") {
        fee_based_error = true;
        errorText = "Please enter your Fee-based Sales Relevant Fees";
      }
      if (parseInt(event.target.value) === 0) {
        fee_based_error = true;
        errorText = "Please enter a value greater than zero";
      }

      await this.setState({
        fee_based_sales_error: fee_based_error,
        fee_based_sales_error_text: errorText,
        formHasError: fee_based_error,
      });
    } else if (event.target.id === "investment_product_gross") {
      let inv_prod_gross_error = false;
      let errorText = "";
      if (event.target.value === "") {
        inv_prod_gross_error = true;
        errorText =
          "Please enter your Investment Product Gross Dealer Commissions";
      }
      if (parseInt(event.target.value) === 0) {
        inv_prod_gross_error = true;
        errorText = "Please enter a value greater than zero";
      }
      await this.setState({
        investment_product_gross_error: inv_prod_gross_error,
        investment_product_gross_error_text: errorText,
        formHasError: inv_prod_gross_error,
      });
    }
    this.validateFields();
  }
  handleCloseModal(x) {
    if (this.state.form_has_changed) {
      this.setState({ showBackModal: true });
    } else {
      this.setState({ showBackModal: false });
      this.setState({ showModal: false });
      this.cancelClick();
    }
  }
  handleCloseBackModal() {
    this.setState({ showBackModal: false });
  }

  handleBackClick() {
    this.setState({ form_has_changed: false });
    this.handleCloseBackModal();
    this.resetFields();
    this.props.actionCancel();
  }
  render() {
    const errorMessageText = this.props.hasNYRegs
      ? "Please enter First Year Premium"
      : "Please enter First Year Commissions";
    const labelText = this.props.hasNYRegs
      ? "First Year Premium*"
      : "First Year Commissions*";
    return (
      <>
        <div>
          <div id="addressModal"></div>

          <div>
            <Modal
              show={this.props.isOpen && !this.state.showBackModal}
              className="modal-md"
              title=""
              id="PersonalSalesRecordModal"
            >
              <div className="container">
                <div className="modal-header mm-spacing--minor">
                  <h3>
                    {`Personal ${
                      this.props.hasNYRegs ? "Production" : "Sales"
                    } Record`}
                  </h3>
                  <button
                    id="psr_modal_close"
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close modal dialog"
                    onClick={this.handleCloseModal}
                  />
                </div>
                {this.state.step_number === 0 && <ModalLoader />}
                {this.state.step_number > 0 && (
                  <div id="top_element">
                    <div className="modal-body">
                      <div>
                        <div
                          role="alert"
                          className="alert alert-info container"
                        >
                          <span>
                            You are filling this form for the following
                            role/time period only:
                          </span>
                          <br />
                          <div>
                            <strong>{this.state.jobtitle}</strong>
                          </div>
                          <div>
                            <strong> at </strong>
                          </div>
                          <div>
                            <strong>{this.state.companyname}</strong>
                          </div>
                          <div>
                            <strong>
                              {`${Moment(this.state.startdate)
                                .utc()
                                .format("MM/DD/YYYY")}
                               - ${this.state.endDateText}`}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <p id="psr_step_text">
                            <strong>Step {this.state.step_number} of 2</strong>
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <p className="required-field-text">
                            * = Required Field
                          </p>
                        </div>
                      </div>
                      {this.state.step_number === 1 && (
                        <>
                          {this.state.show_individual_life_insurance_panel ===
                            true && (
                            <>
                              <Row>
                                <Col md={12}>
                                  <p id="psr_ind_life_label">
                                    <strong>Individual Life Insurance</strong>
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} sm={12}>
                                  <p id="psr_ind_life_first_year_label">
                                    {labelText}
                                  </p>
                                </Col>
                                <Col md={7} sm={12}>
                                  <div
                                    className={`input-group ${
                                      this.state.ind_life_first_year_error
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="ind_life_first_year_input"
                                  >
                                    <div className="input-group-prepend">
                                      <span
                                        className="input-group-text input-group-text-pad-right"
                                        id="ind_life_first_year_input_$"
                                      >
                                        $
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      id="ind_life_first_year"
                                      className={"form-control input-pad-left"}
                                      spellCheck="false"
                                      maxLength={15}
                                      value={this.state.ind_life_first_year}
                                      onBlur={this.onBlur}
                                      onChange={this.handleChange}
                                      onKeyDown={this.onKeyDown}
                                      onKeyPress={onlyNumeric}
                                      onPaste={pasteCommaDelimited}
                                      autoComplete="off"
                                    />
                                  </div>
                                  {this.state.ind_life_first_year_error && (
                                    <div
                                      id="ind_life_first_year_error"
                                      className="invalid-feedback show psr-error-padding"
                                    >
                                      {errorMessageText}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              {!this.props.hasNYRegs && (
                                <>
                                  <Row>
                                    <Col md={5} sm={12}>
                                      <p id="psr_ind_life_renewal_label">
                                        Renewal Commissions*
                                      </p>
                                    </Col>
                                    <Col md={7} sm={12}>
                                      <div
                                        className={`input-group ${
                                          this.state.ind_life_renewal_error
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="ind_life_renewal_input"
                                      >
                                        <div className="input-group-prepend">
                                          <span
                                            className="input-group-text input-group-text-pad-right"
                                            id="ind_life_renewal_input_$"
                                          >
                                            $
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          id="ind_life_renewal"
                                          className={
                                            "form-control input-pad-left"
                                          }
                                          spellCheck="false"
                                          maxLength={15}
                                          value={this.state.ind_life_renewal}
                                          onBlur={this.onBlur}
                                          onChange={this.handleChange}
                                          onKeyDown={this.onKeyDown}
                                          onKeyPress={onlyNumeric}
                                          onPaste={pasteCommaDelimited}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {this.state.ind_life_renewal_error && (
                                        <div
                                          id="ind_life_renewal_error"
                                          className="invalid-feedback show psr-error-padding"
                                        >
                                          Please enter Renewal Commissions
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </>
                          )}
                          {this.state.show_individual_annuity_panel ===
                            true && (
                            <>
                              <Row>
                                <Col md={12}>
                                  <p id="psr_ind_annuity_label">
                                    <strong>Individual Annuity</strong>
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} sm={12}>
                                  <p id="psr_ind_annuity_first_year_label">
                                    {labelText}
                                  </p>
                                </Col>
                                <Col md={7} sm={12}>
                                  <div
                                    className={`input-group ${
                                      this.state.ind_annuity_first_year_error
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="ind_annuity_first_year_input"
                                  >
                                    <div className="input-group-prepend">
                                      <span
                                        className="input-group-text input-group-text-pad-right"
                                        id="ind_annuity_first_year_input_$"
                                      >
                                        $
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      id="ind_annuity_first_year"
                                      className={"form-control input-pad-left"}
                                      spellCheck="false"
                                      maxLength={15}
                                      value={this.state.ind_annuity_first_year}
                                      onBlur={this.onBlur}
                                      onChange={this.handleChange}
                                      onKeyDown={this.onKeyDown}
                                      onKeyPress={onlyNumeric}
                                      onPaste={pasteCommaDelimited}
                                      autoComplete="off"
                                    />
                                  </div>
                                  {this.state.ind_annuity_first_year_error && (
                                    <div
                                      id="ind_annuity_first_year_error"
                                      className="invalid-feedback show psr-error-padding"
                                    >
                                      {errorMessageText}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              {this.props.hasNYRegs === false && (
                                <>
                                  <Row>
                                    <Col md={5} sm={12}>
                                      <p id="psr_ind_annuity_renewal_label">
                                        Renewal Commissions*
                                      </p>
                                    </Col>
                                    <Col md={7} sm={12}>
                                      <div
                                        className={`input-group ${
                                          this.state.ind_annuity_renewal_error
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="ind_annuity_renewal_input"
                                      >
                                        <div className="input-group-prepend">
                                          <span
                                            className="input-group-text input-group-text-pad-right"
                                            id="ind_annuity_renewal_input_$"
                                          >
                                            $
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          id="ind_annuity_renewal"
                                          className={
                                            "form-control input-pad-left"
                                          }
                                          spellCheck="false"
                                          maxLength={15}
                                          value={this.state.ind_annuity_renewal}
                                          onBlur={this.onBlur}
                                          onChange={this.handleChange}
                                          onKeyDown={this.onKeyDown}
                                          onKeyPress={onlyNumeric}
                                          onPaste={pasteCommaDelimited}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {this.state.ind_annuity_renewal_error && (
                                        <div
                                          id="ind_annuity_renewal_error"
                                          className="invalid-feedback show psr-error-padding"
                                        >
                                          Please enter Renewal Commissions
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </>
                          )}

                          {this.state
                            .show_individual_disability_income_panel ===
                            true && (
                            <>
                              <Row>
                                <Col md={12}>
                                  <p id="psr_ind_disability_label">
                                    <strong>
                                      Individual Disability Income
                                    </strong>
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} sm={12}>
                                  <p id="psr_ind_disability_first_year_label">
                                    {labelText}
                                  </p>
                                </Col>
                                <Col md={7} sm={12}>
                                  <div
                                    className={`input-group ${
                                      this.state.ind_disability_first_year_error
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="ind_disability_first_year_input"
                                  >
                                    <div className="input-group-prepend">
                                      <span
                                        className="input-group-text input-group-text-pad-right"
                                        id="ind_disability_first_year_input_$"
                                      >
                                        $
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      id="ind_disability_first_year"
                                      className={"form-control input-pad-left"}
                                      spellCheck="false"
                                      maxLength={15}
                                      value={
                                        this.state.ind_disability_first_year
                                      }
                                      onBlur={this.onBlur}
                                      onChange={this.handleChange}
                                      onKeyDown={this.onKeyDown}
                                      onKeyPress={onlyNumeric}
                                      onPaste={pasteCommaDelimited}
                                      autoComplete="off"
                                    />
                                  </div>
                                  {this.state
                                    .ind_disability_first_year_error && (
                                    <div
                                      id="ind_disability_first_year_error"
                                      className="invalid-feedback show psr-error-padding"
                                    >
                                      {errorMessageText}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              {this.props.hasNYRegs === false && (
                                <Row>
                                  <Col md={5} sm={12}>
                                    <p id="psr_ind_disability_renewal_label">
                                      Renewal Commissions*
                                    </p>
                                  </Col>
                                  <Col md={7} sm={12}>
                                    <div
                                      className={`input-group ${
                                        this.state.ind_disability_renewal_error
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      id="ind_disability_renewal_input"
                                    >
                                      <div className="input-group-prepend">
                                        <span
                                          className="input-group-text input-group-text-pad-right"
                                          id="ind_disability_renewal_input_$"
                                        >
                                          $
                                        </span>
                                      </div>
                                      <input
                                        type="text"
                                        id="ind_disability_renewal"
                                        className="form-control input-pad-left"
                                        spellCheck="false"
                                        maxLength={15}
                                        value={
                                          this.state.ind_disability_renewal
                                        }
                                        onBlur={this.onBlur}
                                        onChange={this.handleChange}
                                        onKeyDown={this.onKeyDown}
                                        onKeyPress={onlyNumeric}
                                        onPaste={pasteCommaDelimited}
                                        autoComplete="off"
                                      />
                                    </div>
                                    {this.state
                                      .ind_disability_renewal_error && (
                                      <div
                                        id="ind_disability_renewal_error"
                                        className="invalid-feedback show psr-error-padding"
                                      >
                                        Please enter Renewal Commissions
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              )}
                            </>
                          )}

                          {this.state.show_individual_long_term_care_panel ===
                            true && (
                            <>
                              <Row>
                                <Col md={12}>
                                  <p id="psr_ind_longterm_label">
                                    <strong>Individual Long Term Care</strong>
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} sm={12}>
                                  <p id="psr_ind_longterm_first_year_label">
                                    {labelText}
                                  </p>
                                </Col>
                                <Col md={7} sm={12}>
                                  <div
                                    className={`input-group ${
                                      this.state.ind_longterm_first_year_error
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="ind_longterm_first_year_input"
                                  >
                                    <div className="input-group-prepend">
                                      <span
                                        className="input-group-text input-group-text-pad-right"
                                        id="ind_longterm_first_year_input_$"
                                      >
                                        $
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      id="ind_longterm_first_year"
                                      className={"form-control input-pad-left"}
                                      spellCheck="false"
                                      maxLength={15}
                                      value={this.state.ind_longterm_first_year}
                                      onBlur={this.onBlur}
                                      onChange={this.handleChange}
                                      onKeyDown={this.onKeyDown}
                                      onKeyPress={onlyNumeric}
                                      onPaste={pasteCommaDelimited}
                                      autoComplete="off"
                                    />
                                  </div>
                                  {this.state.ind_longterm_first_year_error && (
                                    <div
                                      id="ind_longterm_first_year_error"
                                      className="invalid-feedback show psr-error-padding"
                                    >
                                      {errorMessageText}
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              {this.props.hasNYRegs === false && (
                                <>
                                  <Row>
                                    <Col md={5} sm={12}>
                                      <p id="psr_ind_longterm_renewal_label">
                                        Renewal Commissions*
                                      </p>
                                    </Col>
                                    <Col md={7} sm={12}>
                                      <div
                                        className={`input-group ${
                                          this.state.ind_longterm_renewal_error
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="ind_longterm_renewal_input"
                                      >
                                        <div className="input-group-prepend">
                                          <span
                                            className="input-group-text input-group-text-pad-right"
                                            id="ind_longterm_renewal_input_$"
                                          >
                                            $
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          id="ind_longterm_renewal"
                                          className="form-control input-pad-left"
                                          spellCheck="false"
                                          maxLength={15}
                                          value={
                                            this.state.ind_longterm_renewal
                                          }
                                          onBlur={this.onBlur}
                                          onChange={this.handleChange}
                                          onKeyDown={this.onKeyDown}
                                          onKeyPress={onlyNumeric}
                                          onPaste={pasteCommaDelimited}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {this.state
                                        .ind_longterm_renewal_error && (
                                        <div
                                          id="ind_longterm_renewal_error"
                                          className="invalid-feedback show psr-error-padding"
                                        >
                                          Please enter Renewal Commissions
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </>
                          )}
                          <div className="modal-footer">
                            <Button
                              id="psr_modal_cancel_button"
                              variant={"tertiary"}
                              onClick={this.handleCloseModal}
                            >
                              Cancel
                            </Button>
                            <Button
                              id="next_button"
                              variant={"primary"}
                              onClick={this.nextClick}
                              disabled={this.state.is_next_disabled}
                            >
                              Next
                            </Button>
                          </div>
                        </>
                      )}

                      {this.state.step_number === 2 && (
                        <>
                          {!this.props.hasNYRegs && (
                            <>
                              <Row>
                                <Col md={8}>
                                  <span id="psr_sell_inv_products_label">
                                    In this position, did you sell Investment
                                    Products?*
                                  </span>
                                </Col>
                                <Col md={2}>
                                  <div className="custom-control custom-radio">
                                    <input
                                      type="radio"
                                      id="investment_products_yes"
                                      name="investment_products"
                                      className="custom-control-input"
                                      checked={
                                        this.state.investment_products === "Y"
                                      }
                                      value="Y"
                                      onChange={
                                        this.handleInvestmentProductsChange
                                      }
                                    />
                                    <label
                                      htmlFor="investment_products_yes"
                                      className="custom-control-label"
                                      id="label_investment_products_yes"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                </Col>
                                <Col md={2}>
                                  <div className="custom-control custom-radio">
                                    <input
                                      type="radio"
                                      id="investment_products_no"
                                      name="investment_products"
                                      className="custom-control-input"
                                      checked={
                                        this.state.investment_products === "N"
                                      }
                                      value="N"
                                      onChange={
                                        this.handleInvestmentProductsChange
                                      }
                                    />
                                    <label
                                      htmlFor="investment_products_no"
                                      className="custom-control-label"
                                      id="label_investment_products_no"
                                    >
                                      No
                                    </label>
                                  </div>
                                </Col>
                              </Row>
                            </>
                          )}
                          {this.state.show_investment_products &&
                            this.props.hasNYRegs === false && (
                              <>
                                <div
                                  className="row"
                                  style={{ marginBottom: "1.6rem" }}
                                >
                                  <div className="col-md-12">
                                    <p
                                      id="psr_gross_dealer_comissions_label"
                                      style={{ marginBottom: "5px" }}
                                    >
                                      What were your Investment Product Gross
                                      Dealer Commissions?*
                                    </p>
                                    <div
                                      className="col-md-5"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <div
                                        className={`input-group ${
                                          this.state
                                            .investment_product_gross_error
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="investment_product_gross_input"
                                      >
                                        <div className="input-group-prepend">
                                          <span
                                            className="input-group-text input-group-text-pad-right"
                                            id="investment_product_gross_input_$"
                                          >
                                            $
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          id="investment_product_gross"
                                          className="form-control input-pad-left"
                                          spellCheck="false"
                                          maxLength={15}
                                          value={
                                            this.state.investment_product_gross
                                          }
                                          onBlur={this.onBlur}
                                          onChange={this.handleChange}
                                          onKeyDown={this.onKeyDown}
                                          onKeyPress={onlyNumeric}
                                          onPaste={pasteCommaDelimited}
                                          autoComplete="off"
                                        />
                                      </div>
                                    </div>
                                    {this.state
                                      .investment_product_gross_error && (
                                      <div
                                        id="investment_product_gross_error"
                                        className="invalid-feedback show"
                                      >
                                        {
                                          this.state
                                            .investment_product_gross_error_text
                                        }
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          {this.props.hasNYRegs === false && (
                            <Row>
                              <Col md={8}>
                                <span id="psr_fee_based_sales_label">
                                  In this position, did you have any Fee-Based
                                  Sales?*
                                </span>
                              </Col>
                              <Col md={2}>
                                <div className="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    id="fee_based_yes"
                                    name="fee_based"
                                    className="custom-control-input"
                                    checked={this.state.fee_based === "Y"}
                                    value="Y"
                                    onChange={this.handleFeeBasedChange}
                                  />
                                  <label
                                    htmlFor="fee_based_yes"
                                    className="custom-control-label"
                                    id="label_fee_based_yes"
                                  >
                                    Yes
                                  </label>
                                </div>
                              </Col>
                              <Col md={2}>
                                <div className="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    id="fee_based_no"
                                    name="fee_based"
                                    className="custom-control-input"
                                    checked={this.state.fee_based === "N"}
                                    value="N"
                                    onChange={this.handleFeeBasedChange}
                                  />
                                  <label
                                    htmlFor="fee_based_no"
                                    className="custom-control-label"
                                    id="label_fee_based_no"
                                  >
                                    No
                                  </label>
                                </div>
                              </Col>
                            </Row>
                          )}
                          {this.state.show_fee_based &&
                            this.props.hasNYRegs === false && (
                              <>
                                <div
                                  className="row"
                                  style={{ marginBottom: "1.6rem" }}
                                >
                                  <div className="col-md-12">
                                    <p
                                      id="psr_relevant_fees_label"
                                      style={{ marginBottom: "5px" }}
                                    >
                                      What were your Fee-based Sales Relevant
                                      Fees?*
                                    </p>
                                    <div
                                      className="col-md-5"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <div
                                        className={`input-group ${
                                          this.state.fee_based_sales_error
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="fee_based_sales_input"
                                      >
                                        <div className="input-group-prepend">
                                          <span
                                            className="input-group-text input-group-text-pad-right"
                                            id="fee_based_sales_input_$"
                                          >
                                            $
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          id="fee_based_sales"
                                          className="form-control input-pad-left"
                                          spellCheck="false"
                                          maxLength={15}
                                          value={this.state.fee_based_sales}
                                          onBlur={this.onBlur}
                                          onChange={this.handleChange}
                                          onKeyDown={this.onKeyDown}
                                          onKeyPress={onlyNumeric}
                                          onPaste={pasteCommaDelimited}
                                          autoComplete="off"
                                        />
                                      </div>
                                    </div>
                                    {this.state.fee_based_sales_error && (
                                      <div
                                        id="fee_based_sales_error"
                                        className="invalid-feedback show"
                                      >
                                        {this.state.fee_based_sales_error_text}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}

                          <Row>
                            <Col md={8}>
                              <span id="psr_financial_planning_label">
                                In this position, did you sell Financial
                                Planning?*
                              </span>
                            </Col>
                            <Col md={2}>
                              <div className="custom-control custom-radio">
                                <input
                                  type="radio"
                                  id="financial_planning_yes"
                                  name="financial_planning"
                                  className="custom-control-input"
                                  checked={
                                    this.state.financial_planning === "Y"
                                  }
                                  value="Y"
                                  onChange={this.handleFinancialPlanningChange}
                                />
                                <label
                                  htmlFor="financial_planning_yes"
                                  className="custom-control-label"
                                  id="label_financial_planning_yes"
                                >
                                  Yes
                                </label>
                              </div>
                            </Col>
                            <Col md={2}>
                              <div className="custom-control custom-radio">
                                <input
                                  type="radio"
                                  id="financial_planning_no"
                                  name="financial_planning"
                                  className="custom-control-input"
                                  checked={
                                    this.state.financial_planning === "N"
                                  }
                                  value="N"
                                  onChange={this.handleFinancialPlanningChange}
                                />
                                <label
                                  htmlFor="financial_planning_no"
                                  className="custom-control-label"
                                  id="label_financial_planning_no"
                                >
                                  No
                                </label>
                              </div>
                            </Col>
                          </Row>
                          {this.state.show_financial_planning && (
                            <>
                              <div
                                className="row"
                                style={{ marginBottom: "1.6rem" }}
                              >
                                <div className="col-md-12">
                                  <p
                                    id="psr_number_of_financial_plans_label"
                                    style={{ marginBottom: "5px" }}
                                  >
                                    What number of financial plans did you
                                    sell?*
                                  </p>
                                  <div
                                    className="col-md-5"
                                    style={{ paddingLeft: "0px" }}
                                  >
                                    <input
                                      type="text"
                                      id="number_financial_plans"
                                      className={
                                        this.state.number_financial_plans_error
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      spellCheck="false"
                                      maxLength={11}
                                      value={this.state.number_financial_plans}
                                      onBlur={this.onBlur}
                                      onChange={this.handleChange}
                                      onKeyDown={this.onKeyDown}
                                      onKeyPress={onlyNumeric}
                                      onPaste={pasteValue}
                                      autoComplete="off"
                                    />
                                  </div>
                                  {this.state.number_financial_plans_error && (
                                    <div
                                      id="number_financial_plans_error"
                                      className="invalid-feedback show"
                                    >
                                      {
                                        this.state
                                          .number_financial_plans_error_text
                                      }
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="modal-footer">
                            <Button
                              id="psr_modal_cancel_button"
                              variant={"tertiary"}
                              onClick={this.backClick}
                            >
                              Back
                            </Button>

                            <Button
                              id="add_button"
                              onClick={this.addClick}
                              variant={"primary"}
                              disabled={this.state.is_add_disabled}
                            >
                              {this.state.review_edit ? "SAVE" : "ADD"}
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </div>
        <LostDataModal
          isOpen={this.state.showBackModal}
          handleClose={this.handleCloseBackModal}
          handleProceed={this.handleBackClick}
        />
      </>
    );
  }
}

export default PersonalSalesRecordModal;
